var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-tabs my-4"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-dark",class:{ active: _vm.utilityTab === 'notes' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setUtilityTab('notes')}}},[_vm._v("\n      "+_vm._s(_vm._f("translate")('Notes'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }